import { postForm } from './api'

// Fetches the photos of an album. This is the same `POST /album/getAlbum`
// endpoint the previous Vue 2 implementation used.
export function getAlbum(albumId) {
  return postForm('/album/getAlbum', { id: albumId })
}
